import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminApi } from "@/lib/api";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await adminApi.post("/admin/auth/login", { email, password });
      localStorage.setItem("wyv_admin_token", r.data.token);
      localStorage.setItem("wyv_admin", JSON.stringify(r.data.admin));
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8">
          <div className="flex items-center gap-3 mb-2">
            <span className="h-10 w-10 rounded-lg bg-primary flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-white" />
            </span>
            <div>
              <h1 className="font-heading font-bold text-lg text-foreground">Witness Your Vote</h1>
              <p className="text-xs text-muted-foreground">Administrator access</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mb-6">
            Restricted area. All actions are recorded in an append-only audit log.
          </p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="admin-email">Email</Label>
              <Input id="admin-email" type="email" className="mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" autoComplete="username" />
            </div>
            <div>
              <Label htmlFor="admin-password">Password</Label>
              <Input id="admin-password" type="password" className="mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" autoComplete="current-password" />
            </div>
            <Button type="submit" className="w-full h-11" disabled={loading || !email || !password} data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
